import { useEffect, useState } from "react";
import UserService from "../../services/UserService";
import CartService from "../../services/CartService";
export default function Orders() {
  const [orders, setOrders] = useState(null);
  const [editingOrderId, setEditingOrderId] = useState(null);
  const [newAddress, setNewAddress] = useState("");
  useEffect(() => {
    UserService.fetchOrders().then((res) => {
      const data = res.data;
      const ordersArray = Array.isArray(data) ? data : [data];
      setOrders(ordersArray);
    }).catch((err) => {
      alert(err.message);
    });
  }, []);
  const handleAddressSave = async (orderId) => {
    try {
      await CartService.updateOrderAddress(orderId, newAddress);
      setOrders((prevOrders) =>
        prevOrders.map((o) =>
          o.orderId === orderId || o.id === orderId || o._id === orderId
            ? { ...o, address: newAddress }
            : o
        )
      );
      setEditingOrderId(null);
      setNewAddress("");
      alert("Address updated successfully!");
    } 
    catch (err) {
      alert(err.message);
    }
  };
  if(!orders) return <p className="dark:text-white">Loading...</p>;
  return (
    <div className="grid gap-6 p-5 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
      {orders.length === 0 ? (
        <p className="dark:text-white">No orders found.</p>
      ) : (
        orders.map((order, idx) => {
          let statusStyle ="bg-gray-200 text-gray-800 dark:bg-gray-800 dark:text-gray-200";
          let statusLabel = order.status || "N/A";
          if (order.status === "captured") {
            statusStyle ="bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200";
            statusLabel = "Processed";
          } 
          else if (
            order.status === "cancled" ||
            order.status === "cancelled"
          ) 
          {
            statusStyle ="bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200";
            statusLabel = "Cancelled";
          } 
          else if (order.status === "dispatched") {
            statusStyle ="bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200";
            statusLabel = "Dispatched";
          }
          const orderKey = order.orderId || order.id || order._id || idx;
            return (
            <div key={orderKey} className="bg-white dark:bg-gray-900 rounded-lg shadow-lg p-6 flex flex-col justify-between h-full">
              <div className="mb-4 flex flex-col gap-2">
              <div className="text-lg font-semibold text-gray-900 dark:text-gray-100 break-words">
                Order #{orderKey}
              </div>
              <div className="text-gray-700 dark:text-gray-300">
                <span className="font-medium">Total:</span> ₹{" "}
                {order.amount || "N/A"}
              </div>
              <div className="text-gray-700 dark:text-gray-300">
                <span className="font-medium">Address:</span>{" "}
                {editingOrderId === orderKey ? (
                <div className="mt-2 flex flex-col sm:flex-row gap-2">
                  <textarea
                  type="text"
                  value={newAddress}
                  onChange={(e) => setNewAddress(e.target.value)}
                  className="border rounded px-2 py-1 text-sm dark:bg-gray-800 dark:text-white w-full resize-none"
                  rows={2}
                  />
                  <div className="flex gap-2">
                  <button
                    onClick={() => handleAddressSave(orderKey)}
                    className="bg-green-500 hover:bg-green-600 text-white px-3 py-1 rounded text-sm"
                  >
                    Save
                  </button>
                  <button
                    onClick={() => {
                    setEditingOrderId(null);
                    setNewAddress("");
                    }}
                    className="bg-gray-400 hover:bg-gray-500 text-white px-3 py-1 rounded text-sm"
                  >
                    Cancel
                  </button>
                  </div>
                </div>
                ) : (
                <span className="break-words">{order.address || "N/A"}</span>
                )}
              </div>
              <span>TrackingId ID: {order.trackingId}</span>
              {statusLabel === "Processed" &&
                editingOrderId !== orderKey && (
                <button
                  onClick={() => {
                  setEditingOrderId(orderKey);
                  setNewAddress(order.address || "");
                  }}
                  className="mt-2 bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded text-sm w-fit"
                >
                  Change Address
                </button>
                )}
              <div
                className={`inline-block px-3 py-1 rounded ${statusStyle} w-fit`}
              >
                <span className="font-medium">Status:</span> {statusLabel}
              </div>
              </div>
              <div className="grid gap-4 sm:grid-cols-1">
              {order.items && order.items.length > 0 ? (
                order.items.map((item, idx2) => (
                <div
                  key={item.itemId || item.id || idx2}
                  className="flex items-center bg-gray-50 dark:bg-gray-700 rounded p-3 mb-2"
                >
                  <img
                  src={item.image || "https://via.placeholder.com/60"}
                  alt={item.name || "Product"}
                  loading="lazy"
                  className="w-16 h-16 object-cover rounded mr-4 flex-shrink-0"
                  />
                  <div className="flex flex-col flex-1 min-w-0">
                  <div className="text-gray-900 dark:text-gray-100 font-medium truncate">
                    {item.name || "Product Name"}
                  </div>
                  <div className="text-gray-600 dark:text-gray-300 text-sm">
                    Price: ₹{item.price || "N/A"}
                  </div>
                  <div className="text-gray-600 dark:text-gray-300 text-sm">
                    Qty: {item.quantity || 1}
                  </div>
                  {item.selectedSize && (
                    <div className="text-gray-600 dark:text-gray-300 text-sm">
                    Size: {item.selectedSize}
                    </div>
                  )}
                  </div>
                </div>
                ))
              ) : (
                <p className="text-gray-500 dark:text-white">
                No items in this order.
                </p>
              )}
              </div>
            </div>
            );
        })
      )}
    </div>
  );
}
